// extracted by mini-css-extract-plugin
module.exports = {"formButton":"AddNote_formButton__ACIK4","sectionTitle":"AddNote_sectionTitle__1sAdU"};